/**
 * sessionStorage操作
 * 存储、读取、删除
 */
const Sess = {
  set(key, value) {
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    return sessionStorage.setItem(key, value);
  },
  get(key) {
    let value = sessionStorage.getItem(key);
    if (/^\{.*\}$/.test(value)) {
      value = JSON.parse(value);
    }
    return value;
  },
  remove(key) {
    return sessionStorage.removeItem(key);
  }
};

export default Sess;